import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AttendanceServices from "../../../services/AttendanceServices";
import Swal from "sweetalert2";
import VehicleServics from "../../../services/VehicleServics";

const CheckOut = ({ show, handleClose, onSuccess }) => {
  const [endKM, setEndKM] = useState("");
  const [dieselOutReading, setDieselOutReading] = useState(""); // ✅ NEW
  const [meterPhoto, setMeterPhoto] = useState(null);
  const [loadingVehicles, setLoadingVehicles] = useState(false);

  const [activeVehicles, setActiveVehicles] = useState([]);
  const [selectedAttendance, setSelectedAttendance] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [isCompressing, setIsCompressing] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);



  // ✅ FETCH ONLY CHECKED-IN VEHICLES
  useEffect(() => {
    if (show) {
      setLoadingVehicles(true); // 🔥 START LOADING

      AttendanceServices.myAttendance()
        .then((res) => {
          const allData = res.data || [];

          const active = allData.filter(
            (item) => item.status === "checkIn"
          );

          setActiveVehicles(active);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setLoadingVehicles(false); // 🔥 STOP LOADING
        });
    }
  }, [show,onSuccess]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ TYPE VALIDATION
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire("Error", "Only JPG/PNG images allowed", "error");
      return;
    }

    // ✅ SIZE VALIDATION
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire("Error", "Image must be less than 5MB", "error");
      return;
    }

    // ✅ CLEAN OLD PREVIEW
    if (previewImage) {
      URL.revokeObjectURL(previewImage);
    }

    const previewURL = URL.createObjectURL(file);
    setPreviewImage(previewURL);

    // ✅ SKIP SMALL FILE
    if (file.size < 300 * 1024) {
      setMeterPhoto(file);
      return;
    }

    setIsCompressing(true);

    try {
      const img = new Image();
      img.src = previewURL;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 800;

        const scaleSize = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scaleSize;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            setIsCompressing(false);

            if (!blob) {
              setMeterPhoto(file);
              return;
            }

            const compressedFile = new File([blob], file.name, {
              type: "image/jpeg",
            });

            setMeterPhoto(compressedFile);
          },
          "image/jpeg",
          0.7
        );
      };

      img.onerror = () => {
        setIsCompressing(false);
        setMeterPhoto(file);
      };
    } catch (err) {
      setIsCompressing(false);
      setMeterPhoto(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedAttendance) {
      Swal.fire("Error", "पहले वाहन चुनें", "error");
      return;
    }

    if (!endKM) {
      Swal.fire("Error", "अंतिम HMR दर्ज करें।", "error");
      return;
    }

    if (!dieselOutReading) {
      Swal.fire("Error", "अंतिम डीज़ल रीडिंग दर्ज करें।", "error");
      return;
    }

    if (!meterPhoto) {
      Swal.fire("Error", "मीटर की फोटो दर्ज करें।", "error");
      return;
    }
    if (Number(endKM) <= 0) {
      Swal.fire("Error", "Valid HMR डालें", "error");
      return;
    }

    if (Number(dieselOutReading) <= 0) {
      Swal.fire("Error", "Valid diesel reading डालें", "error");
      return;
    }

    const formData = new FormData();
    formData.append("attendanceId", selectedAttendance);
    formData.append("endKM", endKM);
    formData.append("dieselOutReading", dieselOutReading); // ✅ NEW
    formData.append("image", meterPhoto);


    try {
      setUploadProgress(0);
      const { data } = await AttendanceServices.checkOut(formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      });

      // ✅ RESET
      setEndKM("");
      setDieselOutReading("");
      setSelectedAttendance("");
      setMeterPhoto(null);
      // ✅ CLEAR FILE INPUT USING REF
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: data.message || "चेकआउट सफल रहा।",
        timer: 2000,
        showConfirmButton: false,
      });
      setPreviewImage(null);
      setUploadProgress(0);
      onSuccess();
      handleClose();


    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.message ||
          "There was a problem processing your request.",
      });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Check Out</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit}>

          {/* VEHICLE DROPDOWN */}
          <div className="form-group mb-3">
            <label>Select Vehicle</label>

            {loadingVehicles ? (
              <div className="text-center py-3">
                <div className="spinner-border text-success"></div>
                <div className="small text-muted mt-2">
                  Loading vehicles...
                </div>
              </div>
            ) : (
              <select
                className="form-control"
                disabled={loadingVehicles}
                value={selectedAttendance}
                onChange={(e) => setSelectedAttendance(e.target.value)}
              >
                <option value="">-- वाहन चुनें --</option>

                {activeVehicles.map((item) => (
                  
                  <option key={item._id} value={item._id}>
                    {item.vehicleName || "N/A"}
                    {item.equipmentNo ? ` / ${item.equipmentNo}` : ""}
                    {item.model ? ` / ${item.model}` : ""}
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* END KM */}
          <div className="form-group mb-3">
            <label>Enter End HMR</label>
            <input
              type="number"
              className="form-control"
              value={endKM}
              onChange={(e) => setEndKM(e.target.value)}
            />
          </div>

          {/* ✅ DIESEL OUT READING */}
          <div className="form-group mb-3">
            <label>Diesel Out Reading</label>
            <input
              type="number"
              className="form-control"
              placeholder="अंतिम डीज़ल रीडिंग दर्ज करें"
              value={dieselOutReading}
              onChange={(e) => setDieselOutReading(e.target.value)}
            />
          </div>

          {/* PHOTO */}
          <div className="form-group mb-3">
            <label>Meter Photo</label>
            <input
              type="file"
              ref={fileInputRef}
              className="form-control"
              onChange={handleFileChange}
            />
          </div>
          {/* ✅ LOADER */}
          {isCompressing && (
            <div className="text-info mb-2">Compressing image...</div>
          )}

          {/* ✅ PREVIEW */}
          {previewImage && (
            <div className="mb-2">
              <img
                src={previewImage}
                alt="preview"
                style={{ width: "100%", maxHeight: "200px", objectFit: "contain" }}
              />
            </div>
          )}

          {/* ✅ UPLOAD PROGRESS */}
          {uploadProgress > 0 && uploadProgress < 100 && (
            <div className="progress mb-2">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${uploadProgress}%` }}
              >
                {uploadProgress}%
              </div>
            </div>
          )}

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="success"
              type="submit"
              disabled={
                isCompressing ||
                (uploadProgress > 0 && uploadProgress < 100) ||
                !selectedAttendance ||
                !endKM ||
                !dieselOutReading ||
                !meterPhoto
              }
            >
              {isCompressing
                ? "Processing..."
                : uploadProgress > 0 && uploadProgress < 100
                  ? `Uploading ${uploadProgress}%`
                  : "Submit"}
            </Button>
          </Modal.Footer>

        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CheckOut;